/*
	Sound Physicians Salesforce/Pardot conversion tracking

	Optional per-page overrides:
		Place this directly in the HTML of the success page, before the main tracking code,
		when a specific success page needs a custom AdRoll segment or GA4 event name.

			window.SOUND_ADROLL_SEGMENT = "YOUR_ADROLL_SEGMENT_ID";
			window.SOUND_GA4_EVENT_NAME = "partnership_opportunity_form_submit";

	High-level flow:

		www2.soundphysicians.com / Salesforce
		├─ Consent gate
		│  ├─ if iframed: async — postMessage to parent requesting consent for
		│  │                       categories ["marketing", "statistics"];
		│  │                       parent replies via postMessage using
		│  │                       categoryRefused(category)
		│  └─ if standalone: only checks if user has GPC/DNT set to opt-out
		│
		├─ Load vendors
		│  ├─ AdRoll: load on all Salesforce pages
		│  ├─ GA4: load only on standalone Salesforce pages
		│  └─ Full Circle DST: load only on standalone Salesforce pages, unless
		│                      dstRefused(); then remove its own Pardot listeners
		│
		└─ On initial load and AJAX DOM mutation
			└─ if Pardot success state detected
					├─ if iframed
					│  ├─ report AdRoll in iframe
					│  └─ postMessage to parent for GA4
					│
					└─ if standalone
						├─ report AdRoll directly
						└─ report GA4 directly

		www.soundphysicians.com / WordPress parent
		├─ Full Circle DST: loaded by the tag in <head>; apply its opt-out before
		│                   window load, and again on each Complianz change
		├─ Consent gate: no GPC/DNT, and neither "marketing" nor "statistics"
		│                explicitly denied in Complianz
		├─ Do not load AdRoll or GA4 in this code because they are loaded via Google Tag Manager
		├─ Listen for Salesforce iframe consent_request, check categoryRefused,
		│  and reply with consent_response
		└─ Listen for Salesforce iframe conversion message and report GA4 through
		   existing site GA4/GTM, and report the Full Circle form fill
*/


var DEFAULT_GA4_EVENT_NAME = "pardot_form_submit";
var DEFAULT_ADROLL_SEGMENT = "58a5bf6b"; // In AdRoll this is: Default Pardot Form Submission

var MESSAGE_TYPE = "soundphysicians:iframe_conversion";
var CONSENT_REQUEST_TYPE = "soundphysicians:consent_request";
var CONSENT_RESPONSE_TYPE = "soundphysicians:consent_response";

var CONSENT_CATEGORIES = ["marketing", "statistics"];
var CONSENT_REQUEST_TIMEOUT_MS = 3000;

/*
	WordPress sites that may embed the Salesforce/Pardot form iframe.
	postMessage targetOrigin and inbound origin checks use this exact list
*/
var PARENT_ORIGINS = [
	"https://www.soundphysicians.com",
	"https://sltcm.soundphysicians.com",
	"https://aco.soundphysicians.com"
];
var SALESFORCE_ORIGIN = "https://www2.soundphysicians.com";
var PARENT_ORIGIN_STORAGE_KEY = "soundphysicians:parent_origin";

var GA4_MEASUREMENT_ID = "G-4ZR8S8LNVV";

/*
	Full Circle stays off until its tag is in <head> on www and the privacy
	policy names it. Off: nothing loads it, and no email is captured or sent
	to the parent page.
*/
var DST_ENABLED = true;

// Issued by Full Circle for this account. domain= shares the visitor cookie across subdomains.
var DST_SCRIPT_SRC = "https://d2i34c80a0ftze.cloudfront.net/fullcircle.js?cid=d05d0ea9-1c9b-4448-b31b-690cd873a0e5&domain=soundphysicians.com";
var DST_CONSENT_CATEGORY = "marketing";
var DST_EMAIL_STORAGE_KEY = "soundphysicians:pardot_email";

var ADROLL_ADV_ID = "B7H7WCIMPRGA7CKTBLHHLM";
var ADROLL_PIX_ID = "5URQALZYO5CRXEMX6UHEU2";
var ADROLL_VERSION = "2.0";

var OBSERVER_TIMEOUT_MS = 30000;

function getGa4EventName() {
	return window.SOUND_GA4_EVENT_NAME || DEFAULT_GA4_EVENT_NAME;
}

function getAdRollSegment() {
	return window.SOUND_ADROLL_SEGMENT || DEFAULT_ADROLL_SEGMENT;
}

function isSalesforcePage() {
	return window.location.origin === SALESFORCE_ORIGIN;
}

function isParentOrigin(origin) {
	return PARENT_ORIGINS.includes(origin);
}

// True on any WordPress parent in PARENT_ORIGINS (not only www).
function isParentPage() {
	return isParentOrigin(window.location.origin);
}

/*
	Resolves which allowlisted parent embeds this iframe so postMessage can
	target that origin instead of a single hard-coded address (or "*").
	Returns null if the origin is missing or not in PARENT_ORIGINS.

	document.referrer names the parent only on the first load of the iframe.
	After the Pardot form posts, the confirmation page loads inside the iframe
	and its referrer is the form page on www2, so the parent origin is kept in
	sessionStorage from the first load and read back from there.
*/
function getParentOrigin() {
	var origin = null;

	// referrer is a full URL; postMessage needs origin only (scheme+host+port).
	if (document.referrer) {
		try {
			origin = new URL(document.referrer).origin;
		} catch (err) {
			origin = null;
		}
	}

	if (isParentOrigin(origin)) {
		try {
			window.sessionStorage.setItem(PARENT_ORIGIN_STORAGE_KEY, origin);
		} catch (err) {
			// If sessionStorage is blocked, a confirmation page cannot find the parent.
		}
		return origin;
	}

	try {
		var stored = window.sessionStorage.getItem(PARENT_ORIGIN_STORAGE_KEY);
		return isParentOrigin(stored) ? stored : null;
	} catch (err) {
		return null;
	}
}

function isInIframe() {
	try {
		return window.self !== window.top;
	} catch (err) {
		return true;
	}
}

function normalizeText(value) {
	return String(value || "").replace(/\s+/g, " ").trim();
}

/*
	Async consent check for use inside the Salesforce iframe.

	Sends a consent_request postMessage to the parent listing the categories
	that must all be approved. The parent checks window.cmplz_has_consent for
	each category and replies with a consent_response message. If the parent
	does not reply within CONSENT_REQUEST_TIMEOUT_MS, callback(false) is called.

	categories  - array of category strings, e.g. ["marketing", "statistics"]
	callback    - function(approved: boolean)
*/
function hasComplianzTrackingConsent(categories, callback) {
	var listener;
	var timeoutId;

	function cleanup() {
		window.removeEventListener("message", listener);
		window.clearTimeout(timeoutId);
	}

	listener = function (event) {
		// Accept consent replies only from an allowlisted parent origin.
		if (!isParentOrigin(event.origin)) return;
		if (!event.data || event.data.type !== CONSENT_RESPONSE_TYPE) return;

		cleanup();
		callback(event.data.approved === true);
	};

	// Target the embedding parent, not a hard-coded origin.
	var parentOrigin = getParentOrigin();

	if (!parentOrigin) {
		console.log(
			"SoundPhysicians: parent origin missing or not allowed, denying consent"
		);
		callback(false);
		return;
	}

	window.addEventListener("message", listener);

	timeoutId = window.setTimeout(function () {
		cleanup();
		console.log("SoundPhysicians: consent request timed out, denying consent");
		callback(false);
	}, CONSENT_REQUEST_TIMEOUT_MS);

	console.log(
		"SoundPhysicians: requesting consent from parent for categories",
		categories
	);

	window.parent.postMessage(
		{ type: CONSENT_REQUEST_TYPE, categories: categories },
		parentOrigin
	);
}

function browserHasGlobalOptOut() {
	var gpcEnabled = navigator.globalPrivacyControl === true;

	var dntValue =
		navigator.doNotTrack ||
		window.doNotTrack ||
		navigator.msDoNotTrack;

	var dntEnabled =
		dntValue === "1" ||
		dntValue === "yes";

	return gpcEnabled || dntEnabled;
}

function readCookie(name) {
	var parts = document.cookie ? document.cookie.split(";") : [];

	for (var i = 0; i < parts.length; i++) {
		var pair = parts[i].trim();

		if (pair.indexOf(name + "=") === 0) {
			return decodeURIComponent(pair.slice(name.length + 1));
		}
	}

	return null;
}

/*
	Complianz runs in US opt-out mode, where no recorded decision is not a
	refusal, but cmplz_has_consent() returns false in both cases. Only an
	explicit deny counts. Complianz writes this cookie on the root domain, so
	www2 reads the same value.
*/
function categoryRefused(category) {
	return readCookie("cmplz_" + category) === "deny";
}

function dstRefused() {
	if (browserHasGlobalOptOut()) return true;
	if (readCookie("pi_opt_in403342") === "false") return true;
	return categoryRefused(DST_CONSENT_CATEGORY);
}

var dstOptedOut = false;

/*
	Full Circle records the visit on window load and tracks unless told not
	to, so this must run before load. trackingOptIn() re-runs Full Circle's
	whole load, so call it only to undo an opt-out made on this page.
*/
function applyDstConsent() {
	if (!window.fcdsc) {
		console.error("SoundPhysicians: fcdsc not defined, Full Circle opt-out not applied");
		return;
	}

	if (dstRefused()) {
		window.fcdsc.trackingOptOut();
		dstOptedOut = true;
		return;
	}

	if (dstOptedOut) {
		window.fcdsc.trackingOptIn();
		dstOptedOut = false;
	}
}

function watchDstConsent() {
	document.addEventListener("cmplz_status_change", function (event) {
		if (!event.detail) return;
		if (event.detail.category !== DST_CONSENT_CATEGORY) return;

		applyDstConsent();
	});
}

/*
	Synchronous consent check used for the parent page and standalone
	Salesforce pages (not iframed). The iframed Salesforce path uses the
	async hasComplianzTrackingConsent() instead.
*/
function hasTrackingConsent() {
	var parentPage = isParentPage();
	var salesforcePage = isSalesforcePage();
	var iframePage = isInIframe();
	var globalOptOut = browserHasGlobalOptOut();

	var approved;
	var reason;

	if (parentPage) {
		var refused = globalOptOut || CONSENT_CATEGORIES.some(categoryRefused);

		approved = !refused;
		reason = refused
			? "parent blocked by GPC/DNT or an explicit Complianz deny"
			: "parent has no GPC/DNT and no explicit Complianz deny";
	} else if (salesforcePage) {
		if (iframePage) {
			approved = false;
			reason = "unexpected iframed Salesforce page for synchronous consent check";
		} else {
			approved = !globalOptOut;
			reason = globalOptOut
				? "standalone Salesforce page blocked by GPC/DNT opt-out"
				: "standalone Salesforce page without global opt-out";
		}
	} else {
		approved = false;
		reason = "unexpected context for synchronous consent check";
	}

	console.log("SoundPhysicians: tracking consent", {
		approved: approved,
		reason: reason,
		criteria: {
			isParentPage: parentPage,
			isSalesforcePage: salesforcePage,
			isInIframe: iframePage,
			browserGlobalOptOut: globalOptOut
		}
	});

	return approved;
}

function shouldLoadAdRoll() {
	return isSalesforcePage();
}

function shouldLoadGa4() {
	if (!isSalesforcePage()) return false;
	return !isInIframe();
}

function loadAdRoll() {
	if (window.__soundAdRollLoadStarted) return;
	window.__soundAdRollLoadStarted = true;

	console.log(
		"SoundPhysicians: loading AdRoll script",
		ADROLL_ADV_ID,
		ADROLL_PIX_ID
	);

	window.adroll_adv_id = ADROLL_ADV_ID;
	window.adroll_pix_id = ADROLL_PIX_ID;
	window.adroll_version = ADROLL_VERSION;

	(function (w, d, e, o, a) {
		w.adroll_tag_source = w.adroll_tag_source || "manual";
		w.__adroll_loaded = true;
		w.adroll = w.adroll || [];
		w.adroll.f = [
			"setProperties",
			"identify",
			"track",
			"identify_email",
			"get_cookie"
		];

		var roundtripUrl =
			"https://s.adroll.com/j/" +
			w.adroll_adv_id +
			"/roundtrip.js";

		for (a = 0; a < w.adroll.f.length; a++) {
			w.adroll[w.adroll.f[a]] =
				w.adroll[w.adroll.f[a]] ||
				(function (n) {
					return function () {
						w.adroll.push([n, arguments]);
					};
				})(w.adroll.f[a]);
		}

		e = d.createElement("script");
		o = d.getElementsByTagName("script")[0];
		e.async = 1;
		e.src = roundtripUrl;

		e.onerror = function () {
			console.error("SoundPhysicians: AdRoll script failed to load");
		};

		o.parentNode.insertBefore(e, o);
	})(window, document);

	if (window.adroll) {
		if (typeof window.adroll.track === "function") {
			window.adroll.track("pageView");
		}
	}
}

function loadGa4() {
	if (window.__soundGa4LoadStarted) return;
	window.__soundGa4LoadStarted = true;

	console.log(
		"SoundPhysicians: loading GA4 script",
		GA4_MEASUREMENT_ID
	);

	window.dataLayer = window.dataLayer || [];

	window.gtag = window.gtag || function () {
		window.dataLayer.push(arguments);
	};

	window.gtag("js", new Date());
	window.gtag("config", GA4_MEASUREMENT_ID);

	var script = document.createElement("script");
	var firstScript = document.getElementsByTagName("script")[0];

	script.async = true;
	script.src =
		"https://www.googletagmanager.com/gtag/js?id=" +
		encodeURIComponent(GA4_MEASUREMENT_ID);

	firstScript.parentNode.insertBefore(script, firstScript);
}

/*
	Not loaded inside the iframe: the parent reports that form fill, using the
	parent's visitor, which is the one carrying the campaign parameters.
*/
function shouldLoadDst() {
	if (!DST_ENABLED) return false;
	if (!isSalesforcePage()) return false;
	if (isInIframe()) return false;
	return !dstRefused();
}

/*
	Full Circle attaches its own listeners to #pardot-form. They report on
	every email change, before submit, and cancel the submit of a prefilled
	form. This file reports once, on the confirmation page, instead.
*/
function detachDstPardotCapture() {
	var form = getPardotForm();
	if (!form) return;

	form.removeEventListener("submit", window.fcdsc.handleSubmit, false);

	var inputs = form.getElementsByTagName("input");

	for (var i = 0; i < inputs.length; i++) {
		inputs[i].removeEventListener("change", window.fcdsc.handleEmailFieldChange);
	}
}

/*
	Full Circle has no command queue like gtag or adroll, so a form fill
	reported before its script runs waits here instead of being dropped.
*/
var dstReadyCallbacks = [];

function whenDstReady(callback) {
	if (window.fcdsc) {
		callback();
		return;
	}

	if (!window.__soundDstLoadStarted) {
		console.error("SoundPhysicians: Full Circle DST not on this page, form fill not reported");
		return;
	}

	dstReadyCallbacks.push(callback);
}

function runDstReadyCallbacks() {
	var callbacks = dstReadyCallbacks;
	dstReadyCallbacks = [];

	for (var i = 0; i < callbacks.length; i++) {
		callbacks[i]();
	}
}

function loadDst() {
	if (window.__soundDstLoadStarted) return;
	window.__soundDstLoadStarted = true;

	// fcdscOnLoad fires after each Full Circle load, including one started by trackingOptIn().
	window.addEventListener("fcdscOnLoad", detachDstPardotCapture);

	if (window.fcdsc) {
		console.log("SoundPhysicians: Full Circle DST already on the page, not loading it again");
		return;
	}

	console.log("SoundPhysicians: loading Full Circle DST script");

	var script = document.createElement("script");
	var firstScript = document.getElementsByTagName("script")[0];

	script.async = true;
	script.src = DST_SCRIPT_SRC;

	script.onload = runDstReadyCallbacks;

	script.onerror = function () {
		dstReadyCallbacks = [];
		console.error("SoundPhysicians: Full Circle DST script failed to load, form fill not reported");
	};

	firstScript.parentNode.insertBefore(script, firstScript);
}

function loadEligibleVendors() {
	if (shouldLoadAdRoll()) {
		loadAdRoll();
	}

	if (shouldLoadGa4()) {
		loadGa4();
	}

	if (shouldLoadDst()) {
		loadDst();
	}
}

function getPardotForm() {
	return document.getElementById("pardot-form");
}

/*
	Pardot renders opaque, per-form field ids, but wraps each field in a
	paragraph named after the prospect field it maps to.
*/
function getPardotEmailField() {
	var form = getPardotForm();
	if (!form) return null;

	return form.querySelector("p.form-field.email input")
		|| form.querySelector('input[type="email"]');
}

/*
	Success is detected by the form being replaced with thank-you text, so the
	email no longer exists at that point. Keep it for the length of the POST.
*/
function rememberPardotEmail() {
	if (!DST_ENABLED) return;

	var form = getPardotForm();
	if (!form) return;

	form.addEventListener("submit", function () {
		var field = getPardotEmailField();
		if (!field || !field.value) return;

		try {
			window.sessionStorage.setItem(
				DST_EMAIL_STORAGE_KEY,
				field.value.trim()
			);
		} catch (err) {
			console.log("SoundPhysicians: sessionStorage blocked, form fill will be unattributed");
		}
	});
}

function takeRememberedEmail() {
	try {
		var value = window.sessionStorage.getItem(DST_EMAIL_STORAGE_KEY);
		window.sessionStorage.removeItem(DST_EMAIL_STORAGE_KEY);
		return value || null;
	} catch (err) {
		return null;
	}
}

function hasRememberedSubmit() {
	try {
		return Boolean(window.sessionStorage.getItem(DST_EMAIL_STORAGE_KEY));
	} catch (err) {
		return false;
	}
}

function isPardotSuccessState() {
	var form = getPardotForm();
	if (!form) return false;

	var text = normalizeText(form.innerText || form.textContent || "");

	var hasThankYouText =
		/thank/i.test(text) ||
		/a team member will be in touch/i.test(text);

	var hasVisibleSubmissionFields = Boolean(
		form.querySelector(
			'input:not([type="hidden"]):not([type="submit"]), textarea, select'
		)
	);

	if (hasVisibleSubmissionFields) return false;
	return hasThankYouText || hasRememberedSubmit();
}

function getReportKey() {
	return [
		"soundphysicians",
		"pardot_success_reported",
		window.location.pathname,
		getGa4EventName(),
		getAdRollSegment()
	].join(":");
}

function hasAlreadyReported() {
	try {
		return window.sessionStorage.getItem(getReportKey()) === "1";
	} catch (err) {
		return false;
	}
}

function markReported() {
	try {
		window.sessionStorage.setItem(getReportKey(), "1");
	} catch (err) {
		// If sessionStorage is blocked, continue.
	}
}

function getPayload() {
	return {
		type: MESSAGE_TYPE,
		eventName: getGa4EventName(),
		adrollSegment: getAdRollSegment(),
		email: takeRememberedEmail(),
		iframeUrl: window.location.href,
		iframeHost: window.location.hostname,
		referrer: document.referrer || null,
		timestamp: new Date().toISOString()
	};
}

function reportAdRoll(payload) {
	if (!window.__soundAdRollLoadStarted) {
		console.error(
			"SoundPhysicians: AdRoll not initialized — was loadAdRoll() called?"
		);
		return;
	}

	if (!window.adroll || typeof window.adroll.track !== "function") {
		console.error(
			"SoundPhysicians: adroll.track not available — was loadAdRoll() called?"
		);
		return;
	}

	console.log(
		"SoundPhysicians: reporting AdRoll segment",
		payload.adrollSegment
	);

	window.adroll.track("pageView", {
		segment_name: payload.adrollSegment
	});
}

function reportGa4(payload) {
	var params = {
		event_category: "form",
		event_label: payload.iframeUrl,
		iframe_host: payload.iframeHost,
		iframe_referrer: payload.referrer,
		conversion_source: "salesforce_pardot",
		transport_type: "beacon"
	};

	console.log(
		"SoundPhysicians: reporting GA4 event",
		payload.eventName,
		params
	);

	if (typeof window.gtag === "function") {
		window.gtag("event", payload.eventName, params);
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(Object.assign({
		event: payload.eventName
	}, params));
}

function reportDst(payload) {
	if (!DST_ENABLED) return;

	if (!payload.email) {
		console.log("SoundPhysicians: no captured email, skipping Full Circle form fill");
		return;
	}

	whenDstReady(function () {
		if (!window.fcdsc || typeof window.fcdsc.trackFormFill !== "function") {
			console.error("SoundPhysicians: fcdsc.trackFormFill not available");
			return;
		}

		console.log("SoundPhysicians: reporting Full Circle form fill");

		window.fcdsc.trackFormFill(payload.email);
	});
}

function handleSalesforceSuccess() {
	if (!isPardotSuccessState()) return;
	if (hasAlreadyReported()) {
		console.log("SoundPhysicians: already reported success, skipping");
		return;
	}

	markReported();

	var payload = getPayload();

	reportAdRoll(payload);

	if (isInIframe()) {
		// Send to the page that embeds this form, if it is allowlisted.
		var parentOrigin = getParentOrigin();

		if (!parentOrigin) {
			console.log(
				"SoundPhysicians: parent origin missing or not allowed, skipping parent conversion message"
			);
			return;
		}

		console.log(
			"SoundPhysicians: sending iframe conversion payload to parent",
			payload
		);
		window.parent.postMessage(payload, parentOrigin);
		return;
	}

	reportGa4(payload);
	reportDst(payload);
}

function observeSalesforceSuccessState() {
	var observer = new MutationObserver(function () {
		handleSalesforceSuccess();

		if (hasAlreadyReported()) {
			observer.disconnect();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
		characterData: true
	});

	window.setTimeout(function () {
		observer.disconnect();
	}, OBSERVER_TIMEOUT_MS);
}

function runSalesforceTracking() {
	loadEligibleVendors();
	rememberPardotEmail();

	handleSalesforceSuccess();

	if (!hasAlreadyReported()) {
		observeSalesforceSuccessState();
	}
}

/*
	Handles a consent_request message from the Salesforce iframe.
	Approves unless the browser sends GPC/DNT or a requested category is
	explicitly denied. A missing or empty category list is not approved.
*/
function handleConsentRequest(event) {
	var categories = event.data.categories;
	var approved;

	console.log(
		"SoundPhysicians: parent received consent request for categories",
		categories
	);

	approved = false;

	if (Array.isArray(categories) && categories.length > 0) {
		approved = !browserHasGlobalOptOut() && !categories.some(categoryRefused);
	}

	console.log("SoundPhysicians: responding to consent request", {
		categories: categories,
		approved: approved
	});

	// Reply to the requesting iframe window; event.origin is that page's
	// origin (already verified as SALESFORCE_ORIGIN in runParentListener).
	event.source.postMessage(
		{ type: CONSENT_RESPONSE_TYPE, approved: approved },
		event.origin
	);
}

function runParentListener() {
	window.addEventListener("message", function (event) {
		if (event.origin !== SALESFORCE_ORIGIN) return;
		if (!event.data) return;

		if (event.data.type === CONSENT_REQUEST_TYPE) {
			handleConsentRequest(event);
			return;
		}

		if (event.data.type === MESSAGE_TYPE) {
			console.log(
				"SoundPhysicians: parent received iframe conversion payload",
				event.data
			);
			reportGa4(event.data);
			reportDst(event.data);
		}
	});
}

function init() {
	if (isSalesforcePage()) {
		if (isInIframe()) {
			// Async path: the iframe cannot read parent-domain cookies, so we ask
			// the parent to check Complianz consent and reply via postMessage.
			hasComplianzTrackingConsent(CONSENT_CATEGORIES, function (approved) {
				console.log("SoundPhysicians: tracking consent", {
					approved: approved,
					reason: approved
						? "parent approved all consent categories"
						: "parent denied one or more consent categories",
					criteria: {
						isParentPage: false,
						isSalesforcePage: true,
						isInIframe: true,
						consentCategories: CONSENT_CATEGORIES
					}
				});

				if (!approved) return;

				runSalesforceTracking();
			});

			return;
		}
	}

	// Synchronous path for standalone Salesforce pages and the parent page.
	if (DST_ENABLED && isParentPage()) {
		applyDstConsent();
		watchDstConsent();
	}

	if (!hasTrackingConsent()) return;

	if (isSalesforcePage()) {
		runSalesforceTracking();
		return;
	}

	if (isParentPage()) {
		runParentListener();
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}

